import { setAddHotels } from 'actions/flightActions';
import Helper from 'app/modules/Helper';
import classNames from 'classnames';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Checkbox from '../../Common/Checkbox';

type AddHotelsCheckboxProps = {
	lng: string;
	addHotelsChecked: boolean;
	setAddHotels: (toggle: boolean) => void;
};

const AddHotelsCheckbox: FC<AddHotelsCheckboxProps> = (props) => {
	const { t } = useTranslation();
	const { lng, setAddHotels, addHotelsChecked } = props;
	const isJapanese = lng === 'jp';
	const isRtlLanguage = Helper.isRtlLanguage(lng);
	return (
		<div
			className={classNames({
				[isRtlLanguage ? 'ms-5' : 'me-5']: true,
			})}
		>
			<Checkbox
				className={classNames({ japanese: isJapanese })}
				checked={addHotelsChecked}
				label={t('keywords.addHotels')}
				id="add-hotels-checkbox"
				onChange={() => setAddHotels(!addHotelsChecked)}
			/>
		</div>
	);
};

export default connect(null, { setAddHotels })(AddHotelsCheckbox);
